module.exports = __webpack_public_path__ + "img/GIFAV_logo.df2de54a.jpg";